import Vue from 'vue'
import Vuex from 'vuex'
import router from "@/router"
import { setLogin } from "../router"

import * as user from '@/api/user'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		user: {}
	},
	mutations: {
		SET_USER: (state, user) => {state.user = user}
	},
	actions: {
		logout: ({ commit }, params) => {   //前端登出
			commit('SET_USER', {});
			setLogin(false);
			user.logout().then(r => {
                if(r.code === 200) {
                    router.push({ path: '/login' })
                }
			});
		},
    goLogin: ({ commit }, params) => {   //清空信息跳转到登录页
			commit('SET_USER', {});
      setLogin(false);
			router.push({ path: '/login' })
		},
		getUserInfo: ({ commit }, params) => {	//获取用户信息
			// return (async function(){
			// 	await user.login().then(r => {
			// 		if (r.code === 200) {
			// 			commit('SET_USER', r.data);
			// 		}
			// 	})
            // }())
            commit('SET_USER', params);
            // setLogin(false);
			// router.push({ path: '/login' })
		}
	}
})

export default store

